export default "__VITE_ASSET__DmRDz7Fg__"